module.exports = __webpack_public_path__ + "img/1.23b25bc.png";